import { formatUrl } from 'url-lib';
import {
    STATIC_MAP_PROXY_HOST_DEV,
    STATIC_MAP_PROXY_HOST_PROD,
    STATIC_MAP_PROXY_URLPATH,
} from './constants';

interface GetStaticMapURLProps {
    width: number;
    height: number;
    styles?: string[];
    [key: string]: any;
}

export const getStaticMapURL = ({
    width,
    height,
    styles,
    ...parameters
}: GetStaticMapURLProps) => {
    // TODO: Remove this once we have a better way to tell vite we need to proxy this request to QA
    const isProduction = process.env.NODE_ENV === 'production';
    const host = isProduction
        ? STATIC_MAP_PROXY_HOST_PROD
        : STATIC_MAP_PROXY_HOST_DEV;

    let queryParams = parameters;

    queryParams = {
        ...queryParams,
        size: `${width}x${height}`,
    };

    let formattedUrl = formatUrl(STATIC_MAP_PROXY_URLPATH, queryParams);

    if (styles) {
        const styleParam = styles.join('&style=');

        formattedUrl = `${formattedUrl}&style=${styleParam}`;
    }

    return `${host}${formattedUrl}`;
};
